let baseUrl = 'https://wocup.bagherawines.auction/api';
let liveUrl = '';
let socketUrl = 'https://wocup.bagherawines.auction/';
let bagheraAuctionUrl = 'https://bagherawines.auction';
let imageUrl = 'https://bagherawines.auction/';

export { baseUrl, liveUrl, socketUrl, bagheraAuctionUrl, imageUrl };
